var _path, _path2, _circle, _path3, _g, _rect, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSession(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 191,
    height: 190,
    viewBox: "0 0 191 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M100.391 190C150.408 190 190.891 148.782 190.891 97.9259C190.891 47.0701 150.408 6 100.391 6C50.5203 6 9.89062 47.2184 9.89062 98.0741C9.89062 148.93 50.5203 190 100.391 190Z",
    fill: "url(#paint0_linear_1848_146676)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M86.114 172.754C133.646 172.754 172.119 134.055 172.119 86.3073C172.119 38.5599 133.646 0 86.114 0C38.7208 0 0.109375 38.6991 0.109375 86.4465C0.109375 134.194 38.7208 172.754 86.114 172.754Z",
    fill: "url(#paint1_linear_1848_146676)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.163,
    cy: 41.4677,
    r: 3.36221,
    fill: "#C4C4C4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M148.39 158.024H22.1815C17.4781 158.024 13.5586 154.138 13.5586 149.474V21.9994C13.5586 17.3356 17.4781 13.4492 22.1815 13.4492H148.39C153.093 13.4492 157.013 17.3356 157.013 21.9994V149.474C157.013 154.138 153.093 158.024 148.39 158.024Z",
    fill: "white",
    stroke: "#D6DDE8",
    strokeOpacity: 0.6,
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.5451 66.8636C97.4485 66.8636 105.477 58.8352 105.477 48.9318C105.477 39.0283 97.4485 31 87.5451 31C77.6416 31 69.6133 39.0283 69.6133 48.9318C69.6133 58.8352 77.6416 66.8636 87.5451 66.8636Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M87.5467 50.0523C91.2605 50.0523 94.2711 47.0417 94.2711 43.3279C94.2711 39.6141 91.2605 36.6035 87.5467 36.6035C83.8329 36.6035 80.8223 39.6141 80.8223 43.3279C80.8223 47.0417 83.8329 50.0523 87.5467 50.0523Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M100.996 61.2643C97.7442 64.7148 93.1718 66.8625 88.1072 66.8625C83.0426 66.8625 78.4702 64.7148 75.2188 61.2643C77.0141 56.0519 82.1061 52.293 88.1072 52.293C94.1083 52.293 99.2003 56.0519 100.996 61.2643Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M133.391 89.6567H36.0572C34.8938 89.6567 33.7305 88.3636 33.7305 87.0704V75.432C33.7305 74.1389 34.8938 72.8457 36.0572 72.8457H133.391C134.554 72.8457 135.717 74.1389 135.717 75.432V87.0704C135.717 88.3636 134.554 89.6567 133.391 89.6567Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M133.391 114.315H36.0572C34.8938 114.315 33.7305 113.022 33.7305 111.729V100.09C33.7305 98.7971 34.8938 97.5039 36.0572 97.5039H133.391C134.554 97.5039 135.717 98.7971 135.717 100.09V111.729C135.717 113.022 134.554 114.315 133.391 114.315Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M133.295 124.4H97.7899C96.5795 124.4 95.3691 125.323 95.3691 127.169V137.322C95.3691 138.706 96.1761 140.091 97.7899 140.091H133.295C134.505 140.091 135.716 139.168 135.716 137.322V127.169C135.716 125.708 134.505 124.4 133.295 124.4Z",
    fill: "#D6DCE8",
    stroke: "#AAB2C5",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 40.4512,
    y: 79.5723,
    width: 43.7087,
    height: 3.36221,
    rx: 1.6811,
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M125.202 131.127H107.006C106.231 131.127 105.457 131.687 105.457 132.248C105.457 132.808 106.231 133.368 107.006 133.368H125.202C125.977 133.368 126.751 132.808 126.751 132.248C126.751 131.407 125.977 131.127 125.202 131.127Z",
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 40.4512,
    y: 104.229,
    width: 3.36221,
    height: 3.36221,
    rx: 1.6811,
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 47.1777,
    y: 104.229,
    width: 3.36221,
    height: 3.36221,
    rx: 1.6811,
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 53.9023,
    y: 104.229,
    width: 3.36221,
    height: 3.36221,
    rx: 1.6811,
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 60.627,
    y: 104.229,
    width: 3.36221,
    height: 3.36221,
    rx: 1.6811,
    fill: "#AAB2C5"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 66.2305,
    y: 104.229,
    width: 3.36221,
    height: 3.36221,
    rx: 1.6811,
    fill: "#AAB2C5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 72.9551,
    y: 104.229,
    width: 3.36221,
    height: 3.36221,
    rx: 1.6811,
    fill: "#AAB2C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9565 118.378L56.2269 90.6479C54.1848 88.6058 54.1848 85.3814 56.2269 83.3393L83.9565 55.6097C85.9986 53.5676 89.223 53.5676 91.2651 55.6097L118.995 83.3393C121.037 85.3814 121.037 88.6058 118.995 90.6479L91.2651 118.378C89.223 120.42 85.9986 120.42 83.9565 118.378Z",
    fill: "url(#paint2_linear_1848_146676)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7467 74.7125L83.7471 74.7199L83.7477 74.7273L84.7237 87.8431C84.8115 89.4752 85.9972 91.1298 87.7407 91.1298C89.4842 91.1298 90.6698 89.4752 90.7576 87.8431L91.7337 74.7273L91.7343 74.7188L91.7348 74.7104C91.8846 72.1013 90.2839 69.6016 87.7407 69.6016C85.1869 69.6016 83.5969 72.1958 83.7467 74.7125Z",
    fill: "white",
    stroke: "#AAB2C5",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7407 96.6406C85.5193 96.6406 83.7363 98.4236 83.7363 100.645C83.7363 102.866 85.5193 104.649 87.7407 104.649C89.962 104.649 91.745 102.866 91.745 100.645C91.745 98.4236 89.962 96.6406 87.7407 96.6406Z",
    fill: "white",
    stroke: "#AAB2C5",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1848_146676",
    x1: 302.713,
    y1: 122.634,
    x2: 140.677,
    y2: 6.26323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4B0D5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1848_146676",
    x1: 69.6133,
    y1: -9.5,
    x2: 77.721,
    y2: 296.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DCE2EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1848_146676",
    x1: 38.9416,
    y1: 56.4346,
    x2: 43.6546,
    y2: 144.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DFE2EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CBD0DE"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSession);
export default __webpack_public_path__ + "static/media/Session.1053cadf0be626bf94e6a1566ef2f837.svg";
export { ForwardRef as ReactComponent };